(function () {
  var btn = document.getElementById('back-to-top-btn');
  if (!btn) return;

  function toggleVisibility() {
    var y = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    btn.classList.toggle('hide-btt', y <= 250);
  }

  // Browsers honour prefers-reduced-motion automatically for `behavior: 'smooth'`,
  // so no extra branch is needed for accessibility.
  btn.addEventListener('click', function (e) {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  window.addEventListener('scroll', toggleVisibility, { passive: true });
  toggleVisibility();
})();
